import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IPagingOptions } from '@/coreDomainsModule/paging';
import { IFilterInfoFromMasterResponse, IFilterInfoRepository, IFilterInfoResponse } from '../interfaces/IFilterInfoRepository';
import { customAxiosInstance } from '../axios/axiosInstance';
import {
  BusinessNameApi,
  BusinessNameResponseAllOfResult,
  BusinessNumberApi,
  BusinessNumberResponseAllOfResult,
  PackageApi,
  PackageResponseAllOfResult,
  SupplierNumberApi,
  SupplierNumberResponseAllOfResult,
  SupplierNameApi,
  SupplierNameResponseAllOfResult,
  WarehouseNumberApi,
  WarehouseNumberResponseAllOfResult,
  WarehouseApi,
  WarehouseResponseAllOfResult,
  SupplierNameFromMasterApi,
  SupplierNameFromMasterResponseAllOfResult,
  BusinessNameFromMasterApi,
  BusinessNameFromMasterResponseAllOfResult,
  WarehouseFromMasterApi,
  WarehouseFromMasterResponseAllOfResult,
  AggregateBusinessResponsibleUserApi,
  AggregateBusinessResponsibleUserResponseAllOfResult,
  UnitApi,
  UnitResponseAllOfResult,
  LeadTimeApi,
  LeadTimeResponseAllOfResult,
  StdInventoryIndicesMinApi,
  StdInventoryIndicesMinResponseAllOfResult,
  StdInventoryIndicesMaxApi,
  StdInventoryIndicesMaxResponseAllOfResult,
  MoqApi,
  MoqResponseAllOfResult,
  ManufacturerApi,
  ManufacturerResponseAllOfResult,
  OrderPackageApi,
  OrderPackageResponseAllOfResult,
  AggregateBusinessGroupFilterInfoApi,
  AggregateBusinessGroupFilterInfoResponseAllOfResult,
} from '../axios/generated/aggregateBusinessManage/api';
import { IError } from '../interfaces/IError';
import { axiosErrorHandler } from '../axios/axiosError';
import {
  OrderAmountApi,
  OrderAmountResponseAllOfResult,
  OrderDateApi,
  OrderDateResponseAllOfResult,
  OrderDeliveryDateApi,
  OrderDeliveryDateResponseAllOfResult,
  OrderDesiredDeliveryDateApi,
  OrderDesiredDeliveryDateResponseAllOfResult,
  OrderIdsApi,
  OrderIdsResponseAllOfResult,
  OrderNumbersApi,
  OrderNumbersResponseAllOfResult,
} from '../axios/generated/orderManage';

import {
  CustomerNumberApi,
  CustomerNumberResponseAllOfResult,
  CustomerNameApi,
  CustomerNameResponseAllOfResult,
  SalesDestinationNumberApi,
  SalesDestinationNumberResponseAllOfResult,
  SalesDestinationNameApi,
  SalesDestinationNameResponseAllOfResult,
  CustomerNameFromMasterApi,
  CustomerNameFromMasterResponseAllOfResult,
  SalesDestinationNameFromMasterApi,
  SalesDestinationNameFromMasterResponseAllOfResult,
  BaseBusinessResponsibleUserApi,
  BaseBusinessResponsibleUserResponseAllOfResult,
  EndUserApi,
  EndUserResponseAllOfResult,
  ForecastForReceiptResponsibleUserApi,
  ForecastForReceiptResponsibleUserResponseAllOfResult,
} from '../axios/generated/baseBusinessManage';
import { IUserService } from '@/coreDomainsModule/services/userService';
import { ILeadTimeInfo } from '@/coreDomainsModule/leadtime';
import { IStdInventoryIndicesInfo } from '@/coreDomainsModule/inventoryIndices';
import {
  DestinationNameApi,
  GetDestinationNameResponseResult,
  GetInvoiceNumberResponseResult,
  GetOrderGroupNameResponseResult,
  InvoiceNumberApi,
  OrderGroupNameApi,
} from '../axios/generated/orderGroupManage';

/**
 * フィルタ情報の永続化の責務を負うインターフェース
 */
export class FilterInfoRepository implements IFilterInfoRepository {
  /**
   * 仕入先CDリストを取得する
   * TODO ページング処理は未実装
   * @param pagingOptions - ページング情報
   * @param supplierName - 仕入先名
   * @param businessNumber - 商品CD
   * @param businessName - 商品名
   * @param packageName - パッケージ量
   * @param warehouseNumber - 倉庫CD
   * @param warehouse - 倉庫
   * @param unit - 単位
   * @param manufacturer - 製造社
   * @param leadTime - リードタイム
   * @param stdInventoryIndicesMin - 標準在庫指数(min)
   * @param stdInventoryIndicesMax - 標準在庫指数(max)
   * @param moq - MOQ
   * @param supplierForecastResponsibleUserId - 仕入先内示担当者ID
   * @param orderPackage - 発注単位
   * @param keyWord - 検索キーワード
   */
  async getSupplierCodeList(
    pagingOptions: IPagingOptions,
    supplierName?: string,
    businessNumber?: string,
    businessName?: string,
    packageName?: string,
    warehouseNumber?: string,
    warehouse?: string,
    unit?: string,
    manufacturer?: string,
    leadTime?: ILeadTimeInfo,
    stdInventoryIndicesMin?: IStdInventoryIndicesInfo,
    stdInventoryIndicesMax?: IStdInventoryIndicesInfo,
    moq?: number,
    supplierForecastResponsibleUserId?: string,
    orderPackage?: string,
    keyWord?: string
  ): Promise<INetworkResult<IFilterInfoResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const supplierNumberApi = new SupplierNumberApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await supplierNumberApi.supplierNumberGet(
        supplierName,
        businessNumber,
        businessName,
        packageName,
        warehouseNumber,
        warehouse,
        unit,
        manufacturer,
        leadTime,
        stdInventoryIndicesMin,
        stdInventoryIndicesMax,
        moq,
        supplierForecastResponsibleUserId,
        orderPackage,
        keyWord
      );
      switch (apiResponse.status) {
        case 200:
          const result: SupplierNumberResponseAllOfResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: result.supplierNumbers,
                pagingOptions: {
                  pageSize: result.supplierNumbers.length,
                  offset: result.supplierNumbers.length,
                  returnCount: result.supplierNumbers.length,
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * 仕入先名リストを取得する
   * TODO ページング処理は未実装
   * @param pagingOptions - ページング情報
   * @param supplierNumber -仕入先CD
   * @param businessNumber - 商品CD
   * @param businessName - 商品名
   * @param packageName - パッケージ量
   * @param warehouseNumber - 倉庫CD
   * @param warehouse - 倉庫
   * @param unit - 単位
   * @param manufacturer - 製造社
   * @param leadTime - リードタイム
   * @param stdInventoryIndicesMin - 標準在庫指数(min)
   * @param stdInventoryIndicesMax - 標準在庫指数(max)
   * @param moq - MOQ
   * @param supplierForecastResponsibleUserId - 仕入先内示担当者ID
   * @param orderPackage - 発注単位
   * @param keyWord - 検索キーワード
   */
  async getSupplierNameList(
    pagingOptions: IPagingOptions,
    supplierNumber?: string,
    businessNumber?: string,
    businessName?: string,
    packageName?: string,
    warehouseNumber?: string,
    warehouse?: string,
    unit?: string,
    manufacturer?: string,
    leadTime?: ILeadTimeInfo,
    stdInventoryIndicesMin?: IStdInventoryIndicesInfo,
    stdInventoryIndicesMax?: IStdInventoryIndicesInfo,
    moq?: number,
    supplierForecastResponsibleUserId?: string,
    orderPackage?: string,
    keyWord?: string
  ): Promise<INetworkResult<IFilterInfoResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const supplierNameApi = new SupplierNameApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await supplierNameApi.supplierNameGet(
        supplierNumber,
        businessNumber,
        businessName,
        packageName,
        warehouseNumber,
        warehouse,
        unit,
        manufacturer,
        leadTime,
        stdInventoryIndicesMin,
        stdInventoryIndicesMax,
        moq,
        supplierForecastResponsibleUserId,
        orderPackage,
        keyWord
      );
      switch (apiResponse.status) {
        case 200:
          const result: SupplierNameResponseAllOfResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: result.supplierNames,
                pagingOptions: {
                  pageSize: result.supplierNames.length,
                  offset: result.supplierNames.length,
                  returnCount: result.supplierNames.length,
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * 商品CDリストを取得する
   * TODO ページング処理は未実装
   * @param pagingOptions - ページング情報
   * @param supplierNumber - 仕入先CD
   * @param supplierName - 仕入先名
   * @param businessName - 商品名
   * @param packageName - パッケージ量
   * @param warehouseNumber - 倉庫CD
   * @param warehouse - 倉庫
   * @param unit - 単位
   * @param manufacturer - 製造社
   * @param leadTime - リードタイム
   * @param stdInventoryIndicesMin - 標準在庫指数(min)
   * @param stdInventoryIndicesMax - 標準在庫指数(max)
   * @param moq - MOQ
   * @param supplierForecastResponsibleUserId - 仕入先内示担当者ID
   * @param orderPackage - 発注単位
   * @param keyWord - 検索キーワード
   */
  async getBusinessCodeList(
    pagingOptions: IPagingOptions,
    supplierNumber?: string,
    supplierName?: string,
    businessName?: string,
    packageName?: string,
    warehouseNumber?: string,
    warehouse?: string,
    unit?: string,
    manufacturer?: string,
    leadTime?: ILeadTimeInfo,
    stdInventoryIndicesMin?: IStdInventoryIndicesInfo,
    stdInventoryIndicesMax?: IStdInventoryIndicesInfo,
    moq?: number,
    supplierForecastResponsibleUserId?: string,
    orderPackage?: string,
    keyWord?: string
  ): Promise<INetworkResult<IFilterInfoResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const businessNumberApi = new BusinessNumberApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await businessNumberApi.businessNumberGet(
        supplierNumber,
        supplierName,
        businessName,
        packageName,
        warehouseNumber,
        warehouse,
        unit,
        manufacturer,
        leadTime,
        stdInventoryIndicesMin,
        stdInventoryIndicesMax,
        moq,
        supplierForecastResponsibleUserId,
        orderPackage,
        keyWord
      );
      switch (apiResponse.status) {
        case 200:
          const result: BusinessNumberResponseAllOfResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: result.businessNumbers,
                pagingOptions: {
                  pageSize: result.businessNumbers.length,
                  offset: result.businessNumbers.length,
                  returnCount: result.businessNumbers.length,
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }
  /**
   * 商品名リストを取得する
   * TODO ページング処理は未実装
   * @param pagingOptions - ページング情報
   * @param supplierNumber - 仕入先CD
   * @param supplierName - 仕入先名
   * @param businessNumber - 商品CD
   * @param packageName - パッケージ量
   * @param warehouseNumber - 倉庫CD
   * @param warehouse - 倉庫
   * @param unit - 単位
   * @param manufacturer - 製造社
   * @param leadTime - リードタイム
   * @param stdInventoryIndicesMin - 標準在庫指数(min)
   * @param stdInventoryIndicesMax - 標準在庫指数(max)
   * @param moq - MOQ
   * @param supplierForecastResponsibleUserId - 仕入先内示担当者ID
   * @param orderPackage - 発注単位
   * @param keyWord - 検索キーワード
   */
  async getBusinessNameList(
    pagingOptions: IPagingOptions,
    supplierNumber?: string,
    supplierName?: string,
    businessNumber?: string,
    packageName?: string,
    warehouseNumber?: string,
    warehouse?: string,
    unit?: string,
    manufacturer?: string,
    leadTime?: ILeadTimeInfo,
    stdInventoryIndicesMin?: IStdInventoryIndicesInfo,
    stdInventoryIndicesMax?: IStdInventoryIndicesInfo,
    moq?: number,
    supplierForecastResponsibleUserId?: string,
    orderPackage?: string,
    keyWord?: string
  ): Promise<INetworkResult<IFilterInfoResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const businessNameApi = new BusinessNameApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await businessNameApi.businessNameGet(
        supplierNumber,
        supplierName,
        businessNumber,
        packageName,
        warehouseNumber,
        warehouse,
        unit,
        manufacturer,
        leadTime,
        stdInventoryIndicesMin,
        stdInventoryIndicesMax,
        moq,
        supplierForecastResponsibleUserId,
        orderPackage,
        keyWord
      );
      switch (apiResponse.status) {
        case 200:
          const result: BusinessNameResponseAllOfResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: result.businessNames,
                pagingOptions: {
                  pageSize: result.businessNames.length,
                  offset: result.businessNames.length,
                  returnCount: result.businessNames.length,
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }
  /**
   * パッケージ量リストを取得する
   * TODO ページング処理は未実装
   * @param pagingOptions - ページング情報
   * @param supplierNumber - 仕入先CD
   * @param supplierName - 仕入先名
   * @param businessNumber - 商品CD
   * @param businessName - 商品名
   * @param warehouseNumber - 倉庫CD
   * @param warehouse - 倉庫
   * @param unit - 単位
   * @param manufacturer - 製造社
   * @param leadTime - リードタイム
   * @param stdInventoryIndicesMin - 標準在庫指数(min)
   * @param stdInventoryIndicesMax - 標準在庫指数(max)
   * @param moq - MOQ
   * @param supplierForecastResponsibleUserId - 仕入先内示担当者ID
   * @param orderPackage - 発注単位
   * @param keyWord - 検索キーワード
   */
  async getPackageAmountList(
    pagingOptions: IPagingOptions,
    supplierNumber?: string,
    supplierName?: string,
    businessNumber?: string,
    businessName?: string,
    warehouseNumber?: string,
    warehouse?: string,
    unit?: string,
    manufacturer?: string,
    leadTime?: ILeadTimeInfo,
    stdInventoryIndicesMin?: IStdInventoryIndicesInfo,
    stdInventoryIndicesMax?: IStdInventoryIndicesInfo,
    moq?: number,
    supplierForecastResponsibleUserId?: string,
    orderPackage?: string,
    keyWord?: string
  ): Promise<INetworkResult<IFilterInfoResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const packageApi = new PackageApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await packageApi.packageGet(
        supplierNumber,
        supplierName,
        businessNumber,
        businessName,
        warehouseNumber,
        warehouse,
        unit,
        manufacturer,
        leadTime,
        stdInventoryIndicesMin,
        stdInventoryIndicesMax,
        moq,
        supplierForecastResponsibleUserId,
        orderPackage,
        keyWord
      );
      switch (apiResponse.status) {
        case 200:
          const result: PackageResponseAllOfResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: result.packages,
                pagingOptions: {
                  pageSize: result.packages.length,
                  offset: result.packages.length,
                  returnCount: result.packages.length,
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * 倉庫CDリストを取得する
   * TODO ページング処理は未実装
   * @param pagingOptions - ページング情報
   * @param supplierNumber - 仕入先CD
   * @param supplierName - 仕入先名
   * @param businessNumber - 商品CD
   * @param businessName - 商品名
   * @param packageName - パッケージ量
   * @param warehouse - 倉庫
   * @param unit - 単位
   * @param manufacturer - 製造社
   * @param leadTime - リードタイム
   * @param stdInventoryIndicesMin - 標準在庫指数(min)
   * @param stdInventoryIndicesMax - 標準在庫指数(max)
   * @param moq - MOQ
   * @param supplierForecastResponsibleUserId - 仕入先内示担当者ID
   * @param orderPackage - 発注単位
   * @param keyWord - 検索キーワード
   */
  async getWarehouseCodeList(
    pagingOptions: IPagingOptions,
    supplierNumber?: string,
    supplierName?: string,
    businessNumber?: string,
    businessName?: string,
    packageName?: string,
    warehouse?: string,
    unit?: string,
    manufacturer?: string,
    leadTime?: ILeadTimeInfo,
    stdInventoryIndicesMin?: IStdInventoryIndicesInfo,
    stdInventoryIndicesMax?: IStdInventoryIndicesInfo,
    moq?: number,
    supplierForecastResponsibleUserId?: string,
    orderPackage?: string,
    keyWord?: string
  ): Promise<INetworkResult<IFilterInfoResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const warehouseNumberApi = new WarehouseNumberApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await warehouseNumberApi.warehouseNumberGet(
        supplierNumber,
        supplierName,
        businessNumber,
        businessName,
        packageName,
        warehouse,
        unit,
        manufacturer,
        leadTime,
        stdInventoryIndicesMin,
        stdInventoryIndicesMax,
        moq,
        supplierForecastResponsibleUserId,
        orderPackage,
        keyWord
      );
      switch (apiResponse.status) {
        case 200:
          const result: WarehouseNumberResponseAllOfResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: result.warehouseNumbers,
                pagingOptions: {
                  pageSize: result.warehouseNumbers.length,
                  offset: result.warehouseNumbers.length,
                  returnCount: result.warehouseNumbers.length,
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * 倉庫リストを取得する
   * TODO ページング処理は未実装
   * @param pagingOptions - ページング情報
   * @param supplierNumber - 仕入先CD
   * @param supplierName - 仕入先名
   * @param businessNumber - 商品CD
   * @param businessName - 商品名
   * @param packageName - パッケージ量
   * @param warehouseNumber - 倉庫CD
   * @param unit - 単位
   * @param manufacturer - 製造社
   * @param leadTime - リードタイム
   * @param stdInventoryIndicesMin - 標準在庫指数(min)
   * @param stdInventoryIndicesMax - 標準在庫指数(max)
   * @param moq - MOQ
   * @param supplierForecastResponsibleUserId - 仕入先内示担当者ID
   * @param orderPackage - 発注単位
   * @param keyWord - 検索キーワード
   */
  async getWarehouseList(
    pagingOptions: IPagingOptions,
    supplierNumber?: string,
    supplierName?: string,
    businessNumber?: string,
    businessName?: string,
    packageName?: string,
    warehouseNumber?: string,
    unit?: string,
    manufacturer?: string,
    leadTime?: ILeadTimeInfo,
    stdInventoryIndicesMin?: IStdInventoryIndicesInfo,
    stdInventoryIndicesMax?: IStdInventoryIndicesInfo,
    moq?: number,
    supplierForecastResponsibleUserId?: string,
    orderPackage?: string,
    keyWord?: string
  ): Promise<INetworkResult<IFilterInfoResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const warehouseApi = new WarehouseApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await warehouseApi.warehouseGet(
        supplierNumber,
        supplierName,
        businessNumber,
        businessName,
        packageName,
        warehouseNumber,
        unit,
        manufacturer,
        leadTime,
        stdInventoryIndicesMin,
        stdInventoryIndicesMax,
        moq,
        supplierForecastResponsibleUserId,
        orderPackage,
        keyWord
      );
      switch (apiResponse.status) {
        case 200:
          const result: WarehouseResponseAllOfResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: result.warehouses,
                pagingOptions: {
                  pageSize: result.warehouses.length,
                  offset: result.warehouses.length,
                  returnCount: result.warehouses.length,
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * 単位リストを取得する
   * TODO ページング処理は未実装
   * @param pagingOptions - ページング情報
   * @param supplierNumber - 仕入先CD
   * @param supplierName - 仕入先名
   * @param businessNumber - 商品CD
   * @param businessName - 商品名
   * @param packageName - パッケージ量
   * @param warehouseNumber - 倉庫CD
   * @param warehouse - 倉庫
   * @param manufacturer - 製造社
   * @param leadTime - リードタイム
   * @param stdInventoryIndicesMin - 標準在庫指数(min)
   * @param stdInventoryIndicesMax - 標準在庫指数(max)
   * @param moq - MOQ
   * @param supplierForecastResponsibleUserId - 仕入先内示担当者ID
   * @param orderPackage - 発注単位
   * @param keyWord - 検索キーワード
   */
  async getUnitList(
    pagingOptions: IPagingOptions,
    supplierNumber?: string,
    supplierName?: string,
    businessNumber?: string,
    businessName?: string,
    packageName?: string,
    warehouseNumber?: string,
    warehouse?: string,
    manufacturer?: string,
    leadTime?: ILeadTimeInfo,
    stdInventoryIndicesMin?: IStdInventoryIndicesInfo,
    stdInventoryIndicesMax?: IStdInventoryIndicesInfo,
    moq?: number,
    supplierForecastResponsibleUserId?: string,
    orderPackage?: string,
    keyWord?: string
  ): Promise<INetworkResult<IFilterInfoResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const unitApi = new UnitApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await unitApi.unitGet(
        supplierNumber,
        supplierName,
        businessNumber,
        businessName,
        packageName,
        warehouseNumber,
        warehouse,
        manufacturer,
        leadTime,
        stdInventoryIndicesMin,
        stdInventoryIndicesMax,
        moq,
        supplierForecastResponsibleUserId,
        orderPackage,
        keyWord
      );
      switch (apiResponse.status) {
        case 200:
          const result: UnitResponseAllOfResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: result.units,
                pagingOptions: {
                  pageSize: result.units.length,
                  offset: result.units.length,
                  returnCount: result.units.length,
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * 製造社リストを取得する
   * TODO ページング処理は未実装
   * @param pagingOptions - ページング情報
   * @param supplierNumber - 仕入先CD
   * @param supplierName - 仕入先名
   * @param businessNumber - 商品CD
   * @param businessName - 商品名
   * @param packageName - パッケージ量
   * @param warehouseNumber - 倉庫CD
   * @param warehouse - 倉庫
   * @param unit - 単位
   * @param leadTime - リードタイム
   * @param stdInventoryIndicesMin - 標準在庫指数(min)
   * @param stdInventoryIndicesMax - 標準在庫指数(max)
   * @param moq - MOQ
   * @param supplierForecastResponsibleUserId - 仕入先内示担当者ID
   * @param orderPackage - 発注単位
   * @param keyWord - 検索キーワード
   */
  async getManufacturerList(
    pagingOptions: IPagingOptions,
    supplierNumber?: string,
    supplierName?: string,
    businessNumber?: string,
    businessName?: string,
    packageName?: string,
    warehouseNumber?: string,
    warehouse?: string,
    unit?: string,
    leadTime?: ILeadTimeInfo,
    stdInventoryIndicesMin?: IStdInventoryIndicesInfo,
    stdInventoryIndicesMax?: IStdInventoryIndicesInfo,
    moq?: number,
    supplierForecastResponsibleUserId?: string,
    orderPackage?: string,
    keyWord?: string
  ): Promise<INetworkResult<IFilterInfoResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const manufacturerApi = new ManufacturerApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await manufacturerApi.manufacturerGet(
        supplierNumber,
        supplierName,
        businessNumber,
        businessName,
        packageName,
        warehouseNumber,
        warehouse,
        unit,
        leadTime,
        stdInventoryIndicesMin,
        stdInventoryIndicesMax,
        moq,
        supplierForecastResponsibleUserId,
        orderPackage,
        keyWord
      );
      switch (apiResponse.status) {
        case 200:
          const result: ManufacturerResponseAllOfResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: result.manufacturers,
                pagingOptions: {
                  pageSize: result.manufacturers.length,
                  offset: result.manufacturers.length,
                  returnCount: result.manufacturers.length,
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * リードタイムリストを取得する
   * TODO ページング処理は未実装
   * @param pagingOptions - ページング情報
   * @param supplierNumber - 仕入先CD
   * @param supplierName - 仕入先名
   * @param businessNumber - 商品CD
   * @param businessName - 商品名
   * @param packageName - パッケージ量
   * @param warehouseNumber - 倉庫CD
   * @param warehouse - 倉庫
   * @param unit - 単位
   * @param manufacturer - 製造社
   * @param stdInventoryIndicesMin - 標準在庫指数(min)
   * @param stdInventoryIndicesMax - 標準在庫指数(max)
   * @param moq - MOQ
   * @param supplierForecastResponsibleUserId - 仕入先内示担当者ID
   * @param orderPackage - 発注単位
   * @param keyWord - 検索キーワード
   */
  async getLeadTimeList(
    pagingOptions: IPagingOptions,
    supplierNumber?: string,
    supplierName?: string,
    businessNumber?: string,
    businessName?: string,
    packageName?: string,
    warehouseNumber?: string,
    warehouse?: string,
    unit?: string,
    manufacturer?: string,
    stdInventoryIndicesMin?: IStdInventoryIndicesInfo,
    stdInventoryIndicesMax?: IStdInventoryIndicesInfo,
    moq?: number,
    supplierForecastResponsibleUserId?: string,
    orderPackage?: string,
    keyWord?: string
  ): Promise<INetworkResult<IFilterInfoResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const leadTimeApi = new LeadTimeApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await leadTimeApi.leadTimeGet(
        supplierNumber,
        supplierName,
        businessNumber,
        businessName,
        packageName,
        warehouseNumber,
        warehouse,
        unit,
        manufacturer,
        stdInventoryIndicesMin,
        stdInventoryIndicesMax,
        moq,
        supplierForecastResponsibleUserId,
        orderPackage,
        keyWord
      );
      switch (apiResponse.status) {
        case 200:
          const result: LeadTimeResponseAllOfResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: result.leadTimes,
                pagingOptions: {
                  pageSize: result.leadTimes.length,
                  offset: result.leadTimes.length,
                  returnCount: result.leadTimes.length,
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * 最小標準在庫リストを取得する
   * TODO ページング処理は未実装
   * @param pagingOptions - ページング情報
   * @param supplierNumber - 仕入先CD
   * @param supplierName - 仕入先名
   * @param businessNumber - 商品CD
   * @param businessName - 商品名
   * @param packageName - パッケージ量
   * @param warehouseNumber - 倉庫CD
   * @param warehouse - 倉庫
   * @param unit - 単位
   * @param manufacturer - 製造社
   * @param leadTime - リードタイム
   * @param stdInventoryIndicesMax - 標準在庫指数(max)
   * @param moq - MOQ
   * @param supplierForecastResponsibleUserId - 仕入先内示担当者ID
   * @param orderPackage - 発注単位
   * @param keyWord - 検索キーワード
   */
  async getStdInventoryIndicesMinList(
    pagingOptions: IPagingOptions,
    supplierNumber?: string,
    supplierName?: string,
    businessNumber?: string,
    businessName?: string,
    packageName?: string,
    warehouseNumber?: string,
    warehouse?: string,
    unit?: string,
    manufacturer?: string,
    leadTime?: ILeadTimeInfo,
    stdInventoryIndicesMax?: IStdInventoryIndicesInfo,
    moq?: number,
    supplierForecastResponsibleUserId?: string,
    orderPackage?: string,
    keyWord?: string
  ): Promise<INetworkResult<IFilterInfoResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const stdInventoryIndicesMinApi = new StdInventoryIndicesMinApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await stdInventoryIndicesMinApi.stdInventoryIndicesMinGet(
        supplierNumber,
        supplierName,
        businessNumber,
        businessName,
        packageName,
        warehouseNumber,
        warehouse,
        unit,
        manufacturer,
        leadTime,
        stdInventoryIndicesMax,
        moq,
        supplierForecastResponsibleUserId,
        orderPackage,
        keyWord
      );
      switch (apiResponse.status) {
        case 200:
          const result: StdInventoryIndicesMinResponseAllOfResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: result.stdInventoryIndicesMins,
                pagingOptions: {
                  pageSize: result.stdInventoryIndicesMins.length,
                  offset: result.stdInventoryIndicesMins.length,
                  returnCount: result.stdInventoryIndicesMins.length,
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * 最大標準在庫リストを取得する
   * TODO ページング処理は未実装
   * @param pagingOptions - ページング情報
   * @param supplierNumber - 仕入先CD
   * @param supplierName - 仕入先名
   * @param businessNumber - 商品CD
   * @param businessName - 商品名
   * @param packageName - パッケージ量
   * @param warehouseNumber - 倉庫CD
   * @param warehouse - 倉庫
   * @param unit - 単位
   * @param manufacturer - 製造社
   * @param leadTime - リードタイム
   * @param stdInventoryIndicesMin - 標準在庫指数(min)
   * @param moq - MOQ
   * @param supplierForecastResponsibleUserId - 仕入先内示担当者ID
   * @param orderPackage - 発注単位
   * @param keyWord - 検索キーワード
   */
  async getStdInventoryIndicesMaxList(
    pagingOptions: IPagingOptions,
    supplierNumber?: string,
    supplierName?: string,
    businessNumber?: string,
    businessName?: string,
    packageName?: string,
    warehouseNumber?: string,
    warehouse?: string,
    unit?: string,
    manufacturer?: string,
    leadTime?: ILeadTimeInfo,
    stdInventoryIndicesMin?: IStdInventoryIndicesInfo,
    moq?: number,
    supplierForecastResponsibleUserId?: string,
    orderPackage?: string,
    keyWord?: string
  ): Promise<INetworkResult<IFilterInfoResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const stdInventoryIndicesMaxApi = new StdInventoryIndicesMaxApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await stdInventoryIndicesMaxApi.stdInventoryIndicesMaxGet(
        supplierNumber,
        supplierName,
        businessNumber,
        businessName,
        packageName,
        warehouseNumber,
        warehouse,
        unit,
        manufacturer,
        leadTime,
        stdInventoryIndicesMin,
        moq,
        supplierForecastResponsibleUserId,
        orderPackage,
        keyWord
      );
      switch (apiResponse.status) {
        case 200:
          const result: StdInventoryIndicesMaxResponseAllOfResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: result.stdInventoryIndicesMaxes,
                pagingOptions: {
                  pageSize: result.stdInventoryIndicesMaxes.length,
                  offset: result.stdInventoryIndicesMaxes.length,
                  returnCount: result.stdInventoryIndicesMaxes.length,
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * MOQリストを取得する
   * TODO ページング処理は未実装
   * @param pagingOptions - ページング情報
   * @param supplierNumber - 仕入先CD
   * @param supplierName - 仕入先名
   * @param businessNumber - 商品CD
   * @param businessName - 商品名
   * @param packageName - パッケージ量
   * @param warehouseNumber - 倉庫CD
   * @param warehouse - 倉庫
   * @param unit - 単位
   * @param manufacturer - 製造社
   * @param leadTime - リードタイム
   * @param stdInventoryIndicesMin - 標準在庫指数(min)
   * @param stdInventoryIndicesMax - 標準在庫指数(max)
   * @param supplierForecastResponsibleUserId - 仕入先内示担当者ID
   * @param orderPackage - 発注単位
   * @param keyWord - 検索キーワード
   */
  async getMOQList(
    pagingOptions: IPagingOptions,
    supplierNumber?: string,
    supplierName?: string,
    businessNumber?: string,
    businessName?: string,
    packageName?: string,
    warehouseNumber?: string,
    warehouse?: string,
    unit?: string,
    manufacturer?: string,
    leadTime?: ILeadTimeInfo,
    stdInventoryIndicesMin?: IStdInventoryIndicesInfo,
    stdInventoryIndicesMax?: IStdInventoryIndicesInfo,
    supplierForecastResponsibleUserId?: string,
    orderPackage?: string,
    keyWord?: string
  ): Promise<INetworkResult<IFilterInfoResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const moqApi = new MoqApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await moqApi.moqGet(
        supplierNumber,
        supplierName,
        businessNumber,
        businessName,
        packageName,
        warehouseNumber,
        warehouse,
        unit,
        manufacturer,
        leadTime,
        stdInventoryIndicesMin,
        stdInventoryIndicesMax,
        supplierForecastResponsibleUserId,
        orderPackage,
        keyWord
      );
      switch (apiResponse.status) {
        case 200:
          const result: MoqResponseAllOfResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: result.moqs,
                pagingOptions: {
                  pageSize: result.moqs.length,
                  offset: result.moqs.length,
                  returnCount: result.moqs.length,
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * 発注単位リストを取得する
   * TODO ページング処理は未実装
   * @param pagingOptions - ページング情報
   * @param supplierNumber - 仕入先CD
   * @param supplierName - 仕入先名
   * @param businessNumber - 商品CD
   * @param businessName - 商品名
   * @param packageName - パッケージ量
   * @param warehouseNumber - 倉庫CD
   * @param warehouse - 倉庫
   * @param unit - 単位
   * @param manufacturer - 製造社
   * @param leadTime - リードタイム
   * @param stdInventoryIndicesMin - 標準在庫指数(min)
   * @param stdInventoryIndicesMax - 標準在庫指数(max)
   * @param moq - MOQ
   * @param supplierForecastResponsibleUserId - 仕入先内示担当者ID
   * @param keyWord - 検索キーワード
   */
  async getOrderPackageList(
    pagingOptions: IPagingOptions,
    supplierNumber?: string,
    supplierName?: string,
    businessNumber?: string,
    businessName?: string,
    packageName?: string,
    warehouseNumber?: string,
    warehouse?: string,
    unit?: string,
    manufacturer?: string,
    leadTime?: ILeadTimeInfo,
    stdInventoryIndicesMin?: IStdInventoryIndicesInfo,
    stdInventoryIndicesMax?: IStdInventoryIndicesInfo,
    moq?: number,
    supplierForecastResponsibleUserId?: string,
    keyWord?: string
  ): Promise<INetworkResult<IFilterInfoResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const orderPackageApi = new OrderPackageApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await orderPackageApi.orderPackageGet(
        supplierNumber,
        supplierName,
        businessNumber,
        businessName,
        packageName,
        warehouseNumber,
        warehouse,
        unit,
        manufacturer,
        leadTime,
        stdInventoryIndicesMin,
        stdInventoryIndicesMax,
        moq,
        supplierForecastResponsibleUserId,
        keyWord
      );
      switch (apiResponse.status) {
        case 200:
          const result: OrderPackageResponseAllOfResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: result.orderPackages,
                pagingOptions: {
                  pageSize: result.orderPackages.length,
                  offset: result.orderPackages.length,
                  returnCount: result.orderPackages.length,
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * 担当者名リストを取得する
   * @param pagingOptions - ページング情報
   */
  async getStaffNameList(pagingOptions: IPagingOptions): Promise<INetworkResult<IFilterInfoResponse, IError>> {
    try {
      const nameList = await IUserService.getOrganizationUserEmail();
      if (nameList !== undefined) {
        return {
          status: {
            type: 'success',
            data: {
              data: nameList,
              pagingOptions: {
                pageSize: nameList.length,
                offset: nameList.length,
                returnCount: nameList.length,
              },
            },
          },
        };
      } else {
        throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * 売上先CDリストを取得する
   * @param pagingOptions - ページング情報
   * @param customerName - 客先名
   * @param salesDestinationNumber - 送り先CD
   * @param salesDestinationName - 送り先名
   * @param endUser - エンドユーザー
   * @param customerForecastResponsibleUserId - 客先内示担当者
   * @param keyWord - 検索キーワード
   */
  async getCustomerCodeList(
    pagingOptions: IPagingOptions,
    customerName?: string,
    salesDestinationNumber?: string,
    salesDestinationName?: string,
    endUser?: string,
    customerForecastResponsibleUserId?: string,
    keyWord?: string
  ): Promise<INetworkResult<IFilterInfoResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const customerNumberApi = new CustomerNumberApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await customerNumberApi.customerNumberGet(
        customerName,
        salesDestinationNumber,
        salesDestinationName,
        endUser,
        customerForecastResponsibleUserId,
        keyWord
      );
      switch (apiResponse.status) {
        case 200:
          const result: CustomerNumberResponseAllOfResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: result.customerNumbers,
                pagingOptions: {
                  pageSize: result.customerNumbers.length,
                  offset: result.customerNumbers.length,
                  returnCount: result.customerNumbers.length,
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * 売上先名リストを取得する
   * @param pagingOptions - ページング情報
   * @param customerNumber - 客先CD
   * @param salesDestinationNumber - 送り先CD
   * @param salesDestinationName - 送り先名
   * @param endUser - エンドユーザー
   * @param customerForecastResponsibleUserId - 客先内示担当者
   * @param keyWord - 検索キーワード
   */
  async getCustomerNameList(
    pagingOptions: IPagingOptions,
    customerNumber?: string,
    salesDestinationNumber?: string,
    salesDestinationName?: string,
    endUser?: string,
    customerForecastResponsibleUserId?: string,
    keyWord?: string
  ): Promise<INetworkResult<IFilterInfoResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const customerNameApi = new CustomerNameApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await customerNameApi.customerNameGet(
        customerNumber,
        salesDestinationNumber,
        salesDestinationName,
        endUser,
        customerForecastResponsibleUserId,
        keyWord
      );
      switch (apiResponse.status) {
        case 200:
          const result: CustomerNameResponseAllOfResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: result.customerNames,
                pagingOptions: {
                  pageSize: result.customerNames.length,
                  offset: result.customerNames.length,
                  returnCount: result.customerNames.length,
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * 送り先CDリストを取得する
   * @param pagingOptions - ページング情報
   * @param customerNumber - 客先CD
   * @param customerName - 客先名
   * @param salesDestinationName - 送り先名
   * @param endUser - エンドユーザー
   * @param customerForecastResponsibleUserId - 客先内示担当者
   * @param keyWord - 検索キーワード
   */
  async getSalesDestinationCodeList(
    pagingOptions: IPagingOptions,
    customerNumber?: string,
    customerName?: string,
    salesDestinationName?: string,
    endUser?: string,
    customerForecastResponsibleUserId?: string,
    keyWord?: string
  ): Promise<INetworkResult<IFilterInfoResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const salesDestinationNumberApi = new SalesDestinationNumberApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await salesDestinationNumberApi.salesDestinationNumberGet(
        customerNumber,
        customerName,
        salesDestinationName,
        endUser,
        customerForecastResponsibleUserId,
        keyWord
      );
      switch (apiResponse.status) {
        case 200:
          const result: SalesDestinationNumberResponseAllOfResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: result.salesDestinationNumbers,
                pagingOptions: {
                  pageSize: result.salesDestinationNumbers.length,
                  offset: result.salesDestinationNumbers.length,
                  returnCount: result.salesDestinationNumbers.length,
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * 送り先名リストを取得する
   * @param pagingOptions - ページング情報
   * @param customerNumber - 客先CD
   * @param customerName - 客先名
   * @param salesDestinationNumber - 送り先CD
   * @param endUser - エンドユーザー
   * @param customerForecastResponsibleUserId - 客先内示担当者
   * @param keyWord - 検索キーワード
   */
  async getSalesDestinationNameList(
    pagingOptions: IPagingOptions,
    customerNumber?: string,
    customerName?: string,
    salesDestinationNumber?: string,
    endUser?: string,
    customerForecastResponsibleUserId?: string,
    keyWord?: string
  ): Promise<INetworkResult<IFilterInfoResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const salesDestinationNameApi = new SalesDestinationNameApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await salesDestinationNameApi.salesDestinationNameGet(
        customerNumber,
        customerName,
        salesDestinationNumber,
        endUser,
        customerForecastResponsibleUserId,
        keyWord
      );
      switch (apiResponse.status) {
        case 200:
          const result: SalesDestinationNameResponseAllOfResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: result.salesDestinationNames,
                pagingOptions: {
                  pageSize: result.salesDestinationNames.length,
                  offset: result.salesDestinationNames.length,
                  returnCount: result.salesDestinationNames.length,
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * エンドユーザーリストを取得する
   * @param pagingOptions - ページング情報
   * @param customerNumber - 客先CD
   * @param customerName - 客先名
   * @param salesDestinationNumber - 送り先CD
   * @param salesDestinationName - 送り先名
   * @param customerForecastResponsibleUserId - 客先内示担当者
   * @param keyWord - 検索キーワード
   */
  async getEndUserList(
    pagingOptions: IPagingOptions,
    customerNumber?: string,
    customerName?: string,
    salesDestinationNumber?: string,
    salesDestinationName?: string,
    customerForecastResponsibleUserId?: string,
    keyWord?: string
  ): Promise<INetworkResult<IFilterInfoResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const endUserApi = new EndUserApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await endUserApi.endUserGet(
        customerNumber,
        customerName,
        salesDestinationNumber,
        salesDestinationName,
        customerForecastResponsibleUserId,
        keyWord
      );
      switch (apiResponse.status) {
        case 200:
          const result: EndUserResponseAllOfResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: result.endUsers,
                pagingOptions: {
                  pageSize: result.endUsers.length,
                  offset: result.endUsers.length,
                  returnCount: result.endUsers.length,
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * 仕入先内示担当者リストを取得する
   * TODO ページング処理は未実装
   * @param pagingOptions - ページング情報
   * @param supplierNumber - 仕入先CD
   * @param supplierName - 仕入先名
   * @param businessNumber - 商品CD
   * @param businessName - 商品名
   * @param packageName - パッケージ量
   * @param warehouseNumber - 倉庫CD
   * @param warehouse - 倉庫
   * @param unit - 単位
   * @param manufacturer - 製造社
   * @param leadTime - リードタイム
   * @param stdInventoryIndicesMin - 標準在庫指数(min)
   * @param stdInventoryIndicesMax - 標準在庫指数(max)
   * @param moq - MOQ
   * @param orderPackage - 発注単位
   * @param keyWord - 検索キーワード
   */
  async getSupplierForecastResponsibleUserList(
    pagingOptions: IPagingOptions,
    supplierNumber?: string,
    supplierName?: string,
    businessNumber?: string,
    businessName?: string,
    packageName?: string,
    warehouseNumber?: string,
    warehouse?: string,
    unit?: string,
    manufacturer?: string,
    leadTime?: ILeadTimeInfo,
    stdInventoryIndicesMin?: IStdInventoryIndicesInfo,
    stdInventoryIndicesMax?: IStdInventoryIndicesInfo,
    moq?: number,
    orderPackage?: string,
    keyWord?: string
  ): Promise<INetworkResult<IFilterInfoResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const aggregateBusinessResponsibleUserApi = new AggregateBusinessResponsibleUserApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await aggregateBusinessResponsibleUserApi.aggregateBusinessResponsibleUserGet(
        supplierNumber,
        supplierName,
        businessNumber,
        businessName,
        packageName,
        warehouseNumber,
        warehouse,
        unit,
        manufacturer,
        leadTime,
        stdInventoryIndicesMin,
        stdInventoryIndicesMax,
        moq,
        orderPackage,
        keyWord
      );
      switch (apiResponse.status) {
        case 200:
          const result: AggregateBusinessResponsibleUserResponseAllOfResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: result.aggregateBusinessResponsibleUsers,
                pagingOptions: {
                  pageSize: result.aggregateBusinessResponsibleUsers.length,
                  offset: result.aggregateBusinessResponsibleUsers.length,
                  returnCount: result.aggregateBusinessResponsibleUsers.length,
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * 集計グループフィルター情報を取得する
   * @param pagingOptions - ページング情報
   * @param supplierNumber - 仕入先CD
   * @param supplierName - 仕入先名
   * @param businessNumber - 商品CD
   * @param businessName - 商品名
   * @param packageName - パッケージ量
   * @param warehouseNumber - 倉庫CD
   * @param warehouse - 倉庫
   * @param unit - 単位
   * @param manufacturer - 製造社
   * @param leadTime - リードタイム
   * @param stdInventoryIndicesMin - 標準在庫指数(min)
   * @param stdInventoryIndicesMax - 標準在庫指数(max)
   * @param moq - MOQ
   * @param supplierForecastResponsibleUserId - 仕入先内示担当者ID
   * @param orderPackage - 発注単位
   * @param keyWord - 検索キーワード
   */
  async gerAggregateBusinessGroupFilterInfo(
    pagingOptions: IPagingOptions,
    supplierNumber?: string,
    supplierName?: string,
    businessNumber?: string,
    businessName?: string,
    packageName?: string,
    warehouseNumber?: string,
    warehouse?: string,
    unit?: string,
    manufacturer?: string,
    leadTime?: ILeadTimeInfo,
    stdInventoryIndicesMin?: IStdInventoryIndicesInfo,
    stdInventoryIndicesMax?: IStdInventoryIndicesInfo,
    moq?: number,
    supplierForecastResponsibleUserId?: string,
    orderPackage?: string,
    keyWord?: string
  ): Promise<INetworkResult<IFilterInfoResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const aggregateBusinessGroupFilterInfoApi = new AggregateBusinessGroupFilterInfoApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await aggregateBusinessGroupFilterInfoApi.aggregateBusinessGroupFilterInfoGet(
        supplierNumber,
        supplierName,
        businessNumber,
        businessName,
        packageName,
        warehouseNumber,
        warehouse,
        unit,
        manufacturer,
        leadTime,
        stdInventoryIndicesMin,
        stdInventoryIndicesMax,
        moq,
        supplierForecastResponsibleUserId,
        orderPackage,
        keyWord
      );
      switch (apiResponse.status) {
        case 200:
          const result: AggregateBusinessGroupFilterInfoResponseAllOfResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: result.aggregateBusinessGroupFilterInfo,
                pagingOptions: {
                  pageSize: result.aggregateBusinessGroupFilterInfo.length,
                  offset: result.aggregateBusinessGroupFilterInfo.length,
                  returnCount: result.aggregateBusinessGroupFilterInfo.length,
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * 客先内示担当者リストを取得する
   * @param pagingOptions - ページング情報
   * @param customerNumber - 客先CD
   * @param customerName - 客先名
   * @param salesDestinationNumber - 送り先CD
   * @param salesDestinationName - 送り先名
   * @param endUser - エンドユーザー
   * @param keyWord - 検索キーワード
   */
  async getCustomerForecastResponsibleUserList(
    pagingOptions: IPagingOptions,
    customerNumber?: string,
    customerName?: string,
    salesDestinationNumber?: string,
    salesDestinationName?: string,
    endUser?: string,
    keyWord?: string
  ): Promise<INetworkResult<IFilterInfoResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const baseBusinessResponsibleUserApi = new BaseBusinessResponsibleUserApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await baseBusinessResponsibleUserApi.baseBusinessResponsibleUserGet(
        customerNumber,
        customerName,
        salesDestinationNumber,
        salesDestinationName,
        endUser,
        keyWord
      );
      switch (apiResponse.status) {
        case 200:
          const result: BaseBusinessResponsibleUserResponseAllOfResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: result.baseBusinessResponsibleUsers,
                pagingOptions: {
                  pageSize: result.baseBusinessResponsibleUsers.length,
                  offset: result.baseBusinessResponsibleUsers.length,
                  returnCount: result.baseBusinessResponsibleUsers.length,
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * 受領用内示担当者リストを取得する
   * @param pagingOptions - ページング情報
   * @param customerNumber - 客先CD
   * @param customerName - 客先名
   * @param salesDestinationNumber - 送り先CD
   * @param salesDestinationName - 送り先名
   * @param endUser - エンドユーザー
   * @param customerForecastResponsibleUserId - 客先内示担当者
   * @param keyWord - 検索キーワード
   */
  async getForecastForReceiptResponsibleUserList(
    pagingOptions: IPagingOptions,
    customerNumber?: string,
    customerName?: string,
    salesDestinationNumber?: string,
    salesDestinationName?: string,
    endUser?: string,
    customerForecastResponsibleUserId?: string,
    keyWord?: string
  ): Promise<INetworkResult<IFilterInfoResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const forecastForReceiptResponsibleUserApi = new ForecastForReceiptResponsibleUserApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await forecastForReceiptResponsibleUserApi.forecastForReceiptResponsibleUserGet(
        customerNumber,
        customerName,
        salesDestinationNumber,
        salesDestinationName,
        endUser,
        customerForecastResponsibleUserId,
        keyWord
      );
      switch (apiResponse.status) {
        case 200:
          const result: ForecastForReceiptResponsibleUserResponseAllOfResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: result.forecastForReceiptResponsibleUsers,
                pagingOptions: {
                  pageSize: result.forecastForReceiptResponsibleUsers.length,
                  offset: result.forecastForReceiptResponsibleUsers.length,
                  returnCount: result.forecastForReceiptResponsibleUsers.length,
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * 発注数量リストを取得する
   * @param pagingOptions - ページング情報
   * @param keyword - 検索キーワード
   */
  async getOrderAmountList(pagingOptions: IPagingOptions, keyword?: string): Promise<INetworkResult<IFilterInfoResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const orderAmountApi = new OrderAmountApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await orderAmountApi.orderAmountGet(keyword);
      switch (apiResponse.status) {
        case 200:
          const result: OrderAmountResponseAllOfResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: result.orderAmounts,
                pagingOptions: {
                  pageSize: result.orderAmounts.length,
                  offset: result.orderAmounts.length,
                  returnCount: result.orderAmounts.length,
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * 発注日リストを取得する
   * @param pagingOptions - ページング情報
   */
  async getOrderDateList(pagingOptions: IPagingOptions): Promise<INetworkResult<IFilterInfoResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const orderDateApi = new OrderDateApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await orderDateApi.orderDateGet();
      switch (apiResponse.status) {
        case 200:
          const result: OrderDateResponseAllOfResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: result.orderDates,
                pagingOptions: {
                  pageSize: result.orderDates.length,
                  offset: result.orderDates.length,
                  returnCount: result.orderDates.length,
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * 発注納期リストを取得する
   * @param pagingOptions - ページング情報
   */
  async getOrderDeliveryDateList(pagingOptions: IPagingOptions): Promise<INetworkResult<IFilterInfoResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const orderDeliveryDateApi = new OrderDeliveryDateApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await orderDeliveryDateApi.orderDeliveryDateGet();
      switch (apiResponse.status) {
        case 200:
          const result: OrderDeliveryDateResponseAllOfResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: result.orderDeliveryDates,
                pagingOptions: {
                  pageSize: result.orderDeliveryDates.length,
                  offset: result.orderDeliveryDates.length,
                  returnCount: result.orderDeliveryDates.length,
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * 発注希望納期リストを取得する
   * @param pagingOptions - ページング情報
   */
  async getOrderDesiredDeliveryDateList(pagingOptions: IPagingOptions): Promise<INetworkResult<IFilterInfoResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const orderDesiredDeliveryDateApi = new OrderDesiredDeliveryDateApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await orderDesiredDeliveryDateApi.orderDesiredDeliveryDateGet();
      switch (apiResponse.status) {
        case 200:
          const result: OrderDesiredDeliveryDateResponseAllOfResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: result.orderDesiredDeliveryDates,
                pagingOptions: {
                  pageSize: result.orderDesiredDeliveryDates.length,
                  offset: result.orderDesiredDeliveryDates.length,
                  returnCount: result.orderDesiredDeliveryDates.length,
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * 発注IDリストを取得する
   * @param pagingOptions - ページング情報
   * @param keyword - 検索キーワード
   */
  async getOrderIDList(pagingOptions: IPagingOptions, keyword?: string): Promise<INetworkResult<IFilterInfoResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const orderIdsApi = new OrderIdsApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await orderIdsApi.orderIdGet(keyword);
      switch (apiResponse.status) {
        case 200:
          const result: OrderIdsResponseAllOfResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: result.orderIds,
                pagingOptions: {
                  pageSize: result.orderIds.length,
                  offset: result.orderIds.length,
                  returnCount: result.orderIds.length,
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * 発注番号リストを取得する
   * @param pagingOptions - ページング情報
   * @param keyword - 検索キーワード
   */
  async getOrderNumberList(pagingOptions: IPagingOptions, keyword?: string): Promise<INetworkResult<IFilterInfoResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const orderNumbersApi = new OrderNumbersApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await orderNumbersApi.orderNumberGet(keyword);
      switch (apiResponse.status) {
        case 200:
          const result: OrderNumbersResponseAllOfResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: result.orderNumbers,
                pagingOptions: {
                  pageSize: result.orderNumbers.length,
                  offset: result.orderNumbers.length,
                  returnCount: result.orderNumbers.length,
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * 発注グループ名一覧リストを取得する
   * @param pagingOptions - ページング情報
   * @param invoiceNumber - インボイス番号
   * @param destinationName - 仕向地
   * @param keyword - キーワード
   */
  async getOrderGroupNameList(
    pagingOptions: IPagingOptions,
    invoiceNumber?: string,
    destinationName?: string,
    keyword?: string
  ): Promise<INetworkResult<IFilterInfoResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const orderGroupNameApi = new OrderGroupNameApi(undefined, undefined, axiosInstance);
    try {
      const apiResponse = await orderGroupNameApi.getOrderGroupName(invoiceNumber, destinationName, keyword);
      switch (apiResponse.status) {
        case 200:
          const result: GetOrderGroupNameResponseResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: result.orderGroupNames,
                pagingOptions: {
                  pageSize: result.orderGroupNames.length,
                  offset: result.orderGroupNames.length,
                  returnCount: result.orderGroupNames.length,
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * インボイス番号一覧リストを取得する
   * @param pagingOptions - ページング情報
   * @param orderGroupName - 発注グループ名
   * @param destinationName - 仕向地
   * @param keyword - キーワード
   */
  async getInvoiceNumberList(
    pagingOptions: IPagingOptions,
    orderGroupName?: string,
    destinationName?: string,
    keyword?: string
  ): Promise<INetworkResult<IFilterInfoResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const invoiceNumberApi = new InvoiceNumberApi(undefined, undefined, axiosInstance);
    try {
      const apiResponse = await invoiceNumberApi.getInvoiceNumber(orderGroupName, destinationName, keyword);
      switch (apiResponse.status) {
        case 200:
          const result: GetInvoiceNumberResponseResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: result.invoiceNumbers,
                pagingOptions: {
                  pageSize: result.invoiceNumbers.length,
                  offset: result.invoiceNumbers.length,
                  returnCount: result.invoiceNumbers.length,
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * インボイス番号一覧リストを取得する
   * @param pagingOptions - ページング情報
   * @param orderGroupName - 発注グループ名
   * @param invoiceNumber - インボイス番号
   * @param keyword - キーワード
   */
  async getDestinationNameList(
    pagingOptions: IPagingOptions,
    orderGroupName?: string,
    invoiceNumber?: string,
    keyword?: string
  ): Promise<INetworkResult<IFilterInfoResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const destinationNameApi = new DestinationNameApi(undefined, undefined, axiosInstance);
    try {
      const apiResponse = await destinationNameApi.getDestinationName(orderGroupName, invoiceNumber, keyword);
      switch (apiResponse.status) {
        case 200:
          const result: GetDestinationNameResponseResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: result.destinationNames,
                pagingOptions: {
                  pageSize: result.destinationNames.length,
                  offset: result.destinationNames.length,
                  returnCount: result.destinationNames.length,
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * マスタテーブルから仕入先名リストを取得する
   * TODO ページング処理は未実装
   * @param pagingOptions - ページング情報
   * @param supplierName - 仕入先名
   * @param supplierNumber - 仕入先CD
   */
  async getSupplierNameListFromMaster(
    pagingOptions: IPagingOptions,
    supplierName?: string,
    supplierNumber?: string
  ): Promise<INetworkResult<IFilterInfoFromMasterResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const supplierNameFromMasterApi = new SupplierNameFromMasterApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await supplierNameFromMasterApi.supplierNameFromMasterGet(supplierName, supplierNumber);
      switch (apiResponse.status) {
        case 200:
          const result: SupplierNameFromMasterResponseAllOfResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: { supplierNumbers: result.supplierNumbers, supplierNames: result.supplierNames },
                pagingOptions: {
                  supplierNumbers: {
                    pageSize: result.supplierNumbers.length,
                    offset: result.supplierNumbers.length,
                    returnCount: result.supplierNumbers.length,
                  },
                  supplierNames: {
                    pageSize: result.supplierNames.length,
                    offset: result.supplierNames.length,
                    returnCount: result.supplierNames.length,
                  },
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * マスタテーブルから商品名リストを取得する
   * TODO ページング処理は未実装
   * @param pagingOptions - ページング情報
   * @param businessName - 商品名
   * @param businessNumber - 商品CD
   */
  async getBusinessNameListFromMaster(
    pagingOptions: IPagingOptions,
    businessName?: string,
    businessNumber?: string
  ): Promise<INetworkResult<IFilterInfoFromMasterResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const businessNameFromMasterApi = new BusinessNameFromMasterApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await businessNameFromMasterApi.businessNameFromMasterGet(businessName, businessNumber);
      switch (apiResponse.status) {
        case 200:
          const result: BusinessNameFromMasterResponseAllOfResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: { businessNumbers: result.businessNumbers, businessNames: result.businessNames },
                pagingOptions: {
                  businessNumbers: {
                    pageSize: result.businessNumbers.length,
                    offset: result.businessNumbers.length,
                    returnCount: result.businessNumbers.length,
                  },
                  businessNames: {
                    pageSize: result.businessNames.length,
                    offset: result.businessNames.length,
                    returnCount: result.businessNames.length,
                  },
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * マスタテーブルから倉庫リストを取得する
   * TODO ページング処理は未実装
   * @param pagingOptions - ページング情報
   * @param warehouse - 倉庫
   * @param warehouseNumber - 倉庫CD
   */
  async getWarehouseListFromMaster(
    pagingOptions: IPagingOptions,
    warehouse?: string,
    warehouseNumber?: string
  ): Promise<INetworkResult<IFilterInfoFromMasterResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const warehouseFromMasterApi = new WarehouseFromMasterApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await warehouseFromMasterApi.warehouseFromMasterGet(warehouse, warehouseNumber);
      switch (apiResponse.status) {
        case 200:
          const result: WarehouseFromMasterResponseAllOfResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: { warehouseNumbers: result.warehouseNumbers, warehouses: result.warehouses },
                pagingOptions: {
                  warehouseNumbers: {
                    pageSize: result.warehouseNumbers.length,
                    offset: result.warehouseNumbers.length,
                    returnCount: result.warehouseNumbers.length,
                  },
                  warehouses: {
                    pageSize: result.warehouses.length,
                    offset: result.warehouses.length,
                    returnCount: result.warehouses.length,
                  },
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * マスタテーブルから売上先リストを取得する
   * TODO ページング処理は未実装
   * @param pagingOptions - ページング情報
   * @param customerName - 売上先
   * @param customerNumber - 売上先CD
   */
  async getCustomerNameListFromMaster(
    pagingOptions: IPagingOptions,
    customerName?: string,
    customerNumber?: string
  ): Promise<INetworkResult<IFilterInfoFromMasterResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const customerNameFromMasterApi = new CustomerNameFromMasterApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await customerNameFromMasterApi.customerNameFromMasterGet(customerName, customerNumber);
      switch (apiResponse.status) {
        case 200:
          const result: CustomerNameFromMasterResponseAllOfResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: { customerNumbers: result.customerNumbers, customerNames: result.customerNames },
                pagingOptions: {
                  customerNumbers: {
                    pageSize: result.customerNumbers.length,
                    offset: result.customerNumbers.length,
                    returnCount: result.customerNumbers.length,
                  },
                  customerNames: {
                    pageSize: result.customerNames.length,
                    offset: result.customerNames.length,
                    returnCount: result.customerNames.length,
                  },
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * マスタテーブルから送り先リストを取得する
   * TODO ページング処理は未実装
   * @param pagingOptions - ページング情報
   * @param salesDestinationName - 送り先名
   * @param salesDestinationNumber - 送り先CD
   */
  async getSalesDestinationNameListFromMaster(
    pagingOptions: IPagingOptions,
    salesDestinationName?: string,
    salesDestinationNumber?: string
  ): Promise<INetworkResult<IFilterInfoFromMasterResponse, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const salesDestinationNameFromMasterApi = new SalesDestinationNameFromMasterApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await salesDestinationNameFromMasterApi.salesDestinationNameFromMasterGet(
        salesDestinationName,
        salesDestinationNumber
      );
      switch (apiResponse.status) {
        case 200:
          const result: SalesDestinationNameFromMasterResponseAllOfResult = apiResponse.data.result;
          return {
            status: {
              type: 'success',
              data: {
                data: { salesDestinationNumbers: result.salesDestinationNumbers, salesDestinationNames: result.salesDestinationNames },
                pagingOptions: {
                  salesDestinationNumbers: {
                    pageSize: result.salesDestinationNumbers.length,
                    offset: result.salesDestinationNumbers.length,
                    returnCount: result.salesDestinationNumbers.length,
                  },
                  salesDestinationNames: {
                    pageSize: result.salesDestinationNames.length,
                    offset: result.salesDestinationNames.length,
                    returnCount: result.salesDestinationNames.length,
                  },
                },
              },
            },
          };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }
}
